<script>
export default {
  name: 'TechnicianTable',
  props: {
    technicians: {
      type: Array,
      required: true,
    },
  },
  methods: {
    toggleTechnician(id) {
      this.$emit('toggle', id)
    },
  },
}
</script>

<template>
  <div class="mc-notification-setting__card">
    <div class="mc-notification-setting__table-wrapper">
      <table class="mc-notification-setting__table">
        <thead class="mc-notification-setting__table-header">
          <tr>
            <th class="mc-notification-setting__table-header-cell" style="width: 50px"></th>
            <th class="mc-notification-setting__table-header-cell" style="width: 80px">ID</th>
            <th class="mc-notification-setting__table-header-cell">Nama Teknisi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tech in technicians" :key="tech.user_id" class="mc-notification-setting__table-row">
            <td class="mc-notification-setting__table-cell">
              <button type="button" role="checkbox" :aria-checked="tech.selected"
                @click="toggleTechnician(tech.user_id)" class="mc-notification-setting__checkbox"
                :class="{ 'mc-notification-setting__checkbox--checked': tech.selected }">
                <i v-if="tech.selected" class="bx bx-check mc-notification-setting__checkbox-icon" />
              </button>
            </td>
            <td class="mc-notification-setting__table-cell text-muted">
              {{ tech.user_id }}
            </td>
            <td class="mc-notification-setting__table-cell fw-medium">
              {{ tech.fullname }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
